import React from 'react'
import FacetFilterType from 'ui-shared/Facets/Wrappers/FacetFilterType'
import FacetTag from 'ui-shared/Facets/Wrappers/FacetTag'

const FoodFacetSection = () => {
  return (
    <>
      <FacetTag />
      <FacetFilterType />
    </>
  )
}

export default FoodFacetSection
